import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import { formDataFromServerShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { setErrorAlert } from 'AppSrc/core/actions/actions-error-alert';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import { getDisplayOptionsForApprovers } from 'AppSrc/core/components/view-crq-screen/utility-functions/get-display-options-for-approvers';
import {
  VFMultiSelectBase,
} from 'AppSrc/core/components/forms/form-base-components/v-f-multi-select-base';
import {
  addSignatures,
} from 'AppSrc/core/approvers/approvals-queries';
import { CRQ_TRANSITION_CONFIRMATION } from 'AppSrc/core/components/router/routes';
import { APPROVE_APPROVAL_STATUS } from 'AppSrc/core/approvers/approval-statuses';
import {
  APPROVED_FROM_APPROVALS,
} from 'AppSrc/core/crq/crq-status-transitions';
import { Loader } from 'AppSrc/core/components/utility/loader';
import { ApproverPreventError } from '../../forms/form-types/create-crq/section-change-request-summary/summary-error';


const vFParams = {
  fieldTitle: '',
  displayType: 'big',
};

const ApprovalGroupSelector = ({
  value,
  setApproverGroupsSelected,
  displayOptions,
  touched,
  setTouched,
}) => {

  const filteredApprovedDisplayOptions = displayOptions.filter((displayValue) => displayValue.value.status !== 'Approved');

  const formattedDisplayOptions = filteredApprovedDisplayOptions.map((displayOption) => ({
    text: displayOption.text,
    value: displayOption.value.id,
  }));

  const setValue = (newValues) => {
    if (touched !== true) {
      setTouched(true);
    }
    const formattedValues = newValues.map((newValue) => {
      // returns an array
      const filteredOptions = displayOptions.filter((displayOption) => displayOption.value.id === newValue);
      return filteredOptions[0];
    });
    setApproverGroupsSelected(formattedValues);
  };

  const formattedValue = value.map((item) => item.value.id);
  const displayNamesForValues = formattedValue.map((item) => {
    // returns an array
    const filteredOptions = displayOptions.filter((displayOption) => displayOption.value.id === item);
    return filteredOptions[0].text;
  });

  const displayText = displayNamesForValues.length > 0 ? displayNamesForValues.join(', ') : 'Approve on behalf of';


  const errors = {
    inlineErrors: [],
  };

  if (formattedValue.length < 1) {
    errors.inlineErrors.push('Please select an Approver group');
  }

  return (
    <VFMultiSelectBase
      displayOptions={formattedDisplayOptions}
      disabledFieldOptions={{}}
      vFParams={vFParams}
      name="approver-groups"
      value={formattedValue}
      errors={errors}
      touched={touched}
      setValue={setValue}
      displayText={displayText}
    />
  );
};


ApprovalGroupSelector.propTypes = {
  value: PropTypes.arrayOf(PropTypes.object),
  setApproverGroupsSelected: PropTypes.func,
  displayOptions: PropTypes.arrayOf(PropTypes.object),
  touched: PropTypes.bool,
  setTouched: PropTypes.func,
};





const ApprovalModalDisplay = ({
  closeModal,
  formData,
  network,
  crqId,
  errorAlert,
  remedyRefCrqStatus,
}) => {
  const [approverGroupsSelected, setApproverGroupsSelected] = useState([]);
  const [touched, setTouched] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const history = useHistory();

  let readyToSubmit = (isSubmitting !== true) && (approverGroupsSelected.length > 0);
  // Check Change Managment selected or not. offshore -> SIT SGP000000006427 -> Prod SGP000000009029
  const hasChangeManagementSelected = approverGroupsSelected.some((elm) => ((elm.value.groupId !== null) ? ((elm.value.groupId.includes('SGP000000000024')) || (elm.value.groupId.includes('SGP000000009029'))) : false));
  // Prevent approve button if CM group selected as well as ref crq status beyond approvel stage fixed
  const isrefEmpty = JSON.stringify(remedyRefCrqStatus) === '{}' ? true : false;
  // get ref id
  const getCurrentAdjacentRemedyRef = window.sessionStorage.getItem('getCurrentAdjacentRemedyRef');
  // Check ref crq status return true
  const hasCompletedRefJourney = (isrefEmpty === false && ((remedyRefCrqStatus.status === 'Scheduled') || (remedyRefCrqStatus.status === 'Implementation In Progress') || (remedyRefCrqStatus.status === 'Completed'))) ? true : false;
  // based on empty ref objet, Cm group selection and ref journey make false button either normal button CRQ000001012425
  if (network === 'fixed' && hasChangeManagementSelected === true && hasCompletedRefJourney !== true && getCurrentAdjacentRemedyRef !== 'null') {
    readyToSubmit = false;
  }
  const handleApprovalApprove = () => {
    setSubmitting(true);

    const approvalSigntures = approverGroupsSelected.map((approverGroup) => ({
      network,
      crq_id: crqId,
      signature: approverGroup.value.signature,
      reason: '',
      status: APPROVE_APPROVAL_STATUS,
    }));
    addSignatures(approvalSigntures).then((success) => {
      if (success === true) {
        const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
          network,
          crqId,
          transitionId: APPROVED_FROM_APPROVALS,
        });
        history.push(successPath);
      }
    }).catch((error) => {
      console.error(error);
      errorAlert({
        errorTitle: 'Failed to approve CRQ',
        errorText: 'Unable to approve CRQ. It may have been already approved or rejected by a peer. Please refresh the page and try again.',
      });
      setSubmitting(false);
    });
  };

  const displayOptions = getDisplayOptionsForApprovers(formData);

  if (isSubmitting) {
    // set up a loader array that shows the loader at half loaded
    const loaderArray = [true, false];
    return (
      <Loader
        loaderArray={loaderArray}
        loaderTitle="Please wait whilst we approve the CRQ."
        loaderText="Do not close or refresh your browser whilst we do this."
      />
    );
  }
  return (
    <ModalPortal>
      <div
        className="v-f-modal-section submit-crq-modal"
      >
        <div className="v-f-modal-shadow" />
        <div className="v-f-modal-inner">
          <div className="submit-crq-modal-content">
            {
              hasChangeManagementSelected && (hasCompletedRefJourney === false) && (getCurrentAdjacentRemedyRef !== 'null') && (
                <ApproverPreventError />
              )
            }
            <h3>
              On whose behalf are you approving this CRQ:
            </h3>
            <ApprovalGroupSelector
              value={approverGroupsSelected}
              setApproverGroupsSelected={setApproverGroupsSelected}
              displayOptions={displayOptions}
              touched={touched}
              setTouched={setTouched}
            />
            <div className="form-modal-options form-modal-options-space-maker" />
            <div className="form-modal-options">
              <div className="side-left">
                <button
                  type="button"
                  className="cancel-button"
                  onClick={closeModal}
                >
                  Cancel
                </button>
              </div>
              <div className="side-right">
                <button
                  type="button"
                  className={`save-button save-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                  disabled={!readyToSubmit}
                  onClick={handleApprovalApprove}
                >
                  Approve
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

ApprovalModalDisplay.propTypes = {
  formData: formDataFromServerShape,
  closeModal: PropTypes.func,
  network: PropTypes.string,
  crqId: PropTypes.string,
  errorAlert: PropTypes.func,
  remedyRefCrqStatus: PropTypes.string,
};



const mapStateToProps = (state, ownProps) => ({
  formData: state.editForm.formDataById[ownProps.crqId],
  remedyRefCrqStatus: (state.remedyReferenceCrq === undefined && (Object.keys(state.remedyReferenceCrq).length === 0)) ? null : state.remedyReferenceCrq.crqData,
});


const mapDispatchToProps = (dispatch, ownProps) => ({
  errorAlert: (alertData) => {
    dispatch(setErrorAlert(alertData));
  },
});

const ApprovalModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApprovalModalDisplay);





export { ApprovalModal };
